var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24,
    viewBox: "0 0 12 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M135.5,8.25v-3a1.5,1.5,0,0,1,1.5-1.5h1.5V0h-3A4.5,4.5,0,0,0,131,4.5V8.25h-3V12h3V24h4.5V12h3L140,8.25Z",
    transform: "translate(-128)"
  })))));
};
export default SvgFacebook;